import { skipToken, useQuery } from '@tanstack/react-query';

import { getMainPrivateApi } from '#/api/apiCoreSdk';
import {
  APIBankrollPointsResponse,
  APIBankrollResponse,
} from '#/api/bankrollTypes';
import { useSelector } from '#/reduxState/storeCore';

import { minutes, seconds } from './utils';

// export function useInvalidateBankrollQueries() {
//   const queryClient = useQueryClient();
//   const invalidate = useEventCallback(async () => {
//     await queryClient.invalidateQueries({ queryKey: ['bankroll'] });
//   });
//   return invalidate;
// }

export function useBankrollQuery(code?: string) {
  return useQuery<APIBankrollResponse | undefined>({
    queryKey: ['bankroll', code],
    queryFn: !code ? skipToken : () => getMainPrivateApi().getBankroll(code),
    staleTime: seconds(10),
    refetchInterval: minutes(1),
  });
}

export function useWelcomeBonusQuery(code?: string) {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  return useQuery<APIBankrollPointsResponse | undefined>({
    queryKey: ['bankroll-points', walletAddress, code],
    queryFn: !code
      ? skipToken
      : () => getMainPrivateApi().getWelcomeBonus(code, walletAddress),
    staleTime: seconds(10),
    refetchInterval: minutes(1),
  });
}
